/**
 * ROW-REVEAL
 * Entrée en cascade (fondu + léger glissement) des lignes ou des cartes d'une liste une fois chargée.
 * Seules les premières sont animées (les grosses listes restent légères), le délai est plafonné, et tout est coupé
 * pendant un export ou avec « réduire les animations ».
 *
 * `isPending` : la liste est montée mais cachée derrière un skeleton ; les éléments attendent d'être visibles
 * pour démarrer leur entrée (sinon l'animation se terminerait avant qu'on les voie).
 */
import { useAnimationsDisabled } from "./animation-mode.utils"
import { staggerDelay } from "./stagger-delay.utils"

//Nombre d'éléments animés (au-delà, ils apparaissent d'un coup)
export const ROWS_REVEALED = 24

const HIDDEN = { opacity: 0, y: 8 }
const VISIBLE = { opacity: 1, y: 0 }

export function useRowReveal(isPending = false, step = 0.025) {
  const isDisabled = useAnimationsDisabled()

  //Props à étaler sur un motion.* : <motion.tr {...rowReveal(i)}>
  return (index: number) => {
    if (isDisabled || index >= ROWS_REVEALED) return { initial: false as const, animate: VISIBLE }

    return {
      initial: HIDDEN,
      animate: isPending ? HIDDEN : VISIBLE,
      transition: { duration: 0.3, delay: staggerDelay(index, step, 0, 0.4), ease: "easeOut" as const }
    }
  }
}
